import React from "react"
import {FieldInlineEditableProps} from "../../../../render/inline-editable";
import FieldCheckbox_FormCommon from "./form/form-view";

export default function FieldCheckbox_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    return <FieldCheckbox_FormCommon {...props} value={value} onChange={props.onChange} />

}